import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

import { TranslocoPipe } from '@jsverse/transloco';

import { Alert } from '@models/alert.model';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  imports: [MatIcon, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    id: 'de039d29-c72e-4da5-8e84-83b9312966e5',
  },
})
export class SnackbarComponent {
  public data = inject<Alert>(MAT_SNACK_BAR_DATA);
  public snackBarRef = inject<MatSnackBarRef<SnackbarComponent>>(MatSnackBarRef<SnackbarComponent>);
  /** The instance of the component making up the content of the snack bar. */
  iconPosition: string;

  constructor() {
    this.data.title = this.nl2br(this.data.title);
    this.data.message = this.nl2br(this.data.message);
    this.iconPosition = !this.handleAutoclose ? 'left' : 'right';
  }

  /** If the action button should be shown. */
  get handleAutoclose(): boolean {
    return this.data.autoclose;
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }

  private nl2br(str: string): string {
    if (!str) {
      return str;
    }

    return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
}
